import { useState, useEffect } from "react";
import Axios from "middleware/axiosInstance";
import ButtonComponent from "../../../../components/Form/ButtonComponent";
import { Row, Col } from "antd";
import "antd/dist/antd.css";
import useAxios from "../../../../middleware/useAxios";
import "moment/locale/fa";
import {
  Button,
  Form,
  Input,
  Select,
  Space,
  Checkbox,
  Upload,
  Modal,
} from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import { useNavigate } from "react-router-dom";
import { getBase64 } from "functions/globalFunction";

const { Option } = Select;
const { TextArea } = Input;
const CreateCommodityAndServices = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const [showAddModal, setShowAddModal] = useState(false);
  const [allCommodityAndServicesGroup, setAllCommodityAndServicesGroup] =
    useState(null);
  const [hasFeature, setHasFeature] = useState(false);

  const [
    allMeasurementUnits,
    // errorGetAllMeasurementUnits,
    // loadingGetAllMeasurementUnits,
    // refetchAllMeasurementUnits,
  ] = useAxios({
    method: "get",
    url: "/v_sanjesh",
  });

  const [
    allCommodity,
    // errorGetAllCommodity,
    // loadingGetAllCommodity,
    // refetchAllCommodity,
  ] = useAxios({
    method: "get",
    url: "/commodity",
  });

  const createCommodityAndServicesGroupHandler = async (changedValues) => {
    try {
      if (fileList[0]) {
        changedValues.image = await getBase64(fileList[0].originFileObj);
      }
      Axios.post("/commodity", changedValues)
        .then((res) => {
          console.log(res);
          getAllCommodityAndServicesGroup();
          setShowAddModal(false);
          OpenNotificationWithIcon("تایید", "کالای مورد نظر ثبت شد");
          navigate("/warehouse/commodity-and-services");
        })
        .catch((err) => {
          if (
            err.response.data.message.shenaseh[0] ===
            "The shenaseh has already been taken."
          ) {
            OpenNotificationWithIcon(
              "خطا",
              "شناسه وارد شده تکراری است",
              "error"
            );
          } else if (
            err.response.data.message.goods_group_id[0] ===
            "The goods group id field is required."
          ) {
            OpenNotificationWithIcon(
              "خطا",
              "فیلد گروه کالایی اجباری است",
              "error"
            );
          } else if (
            err.response.data.message.name[0] === "The name field is required."
          ) {
            OpenNotificationWithIcon(
              "خطا",
              "وارد کردن نام اجباری است",
              "error"
            );
          }
          console.log(err);
        });
    } catch {
      alert("مشکلی پیش آمده");
    }
  };

  // const editeCommodityAndServiceHandler = () => {
  //   Axios.put(`/commodity/${selectedItem.id}`, editeCommodityAndService)
  //     .then((res) => {
  //       console.log(res);
  //       getAllCommodityAndServicesGroup();
  //       setShowEditModal(false);
  //     })
  //     .catch((res) => {
  //       console.log(res);
  //     });
  // };
  const getAllCommodityAndServicesGroup = () => {
    Axios.get("/goods_groups")
      .then((res) => {
        setAllCommodityAndServicesGroup(res.data);
      })
      .catch(() => {
        setAllCommodityAndServicesGroup(false);
        alert("لیست انبارها دریافت نشد");
        console.log("err");
      });
  };
  // const deleteCommodityAndServicesGroup = () => {
  //   Axios.delete(`/commodity/${selectedItem.id}`)
  //     .then((res) => {
  //       console.log(res);
  //       getAllCommodityAndServicesGroup();
  //     })
  //     .catch((res) => {
  //       console.log(res);
  //     });
  // };
  useEffect(() => {
    getAllCommodityAndServicesGroup();
  }, []);
  // const deleteItemHandler = () => {
  //   if (window.confirm(`آیا انبار "${selectedItem.name}" حذف گردد؟`)) {
  //     deleteCommodityAndServicesGroup();
  //   }
  // };

  // const handleFormChangeValues = async (changedValues) => {
  //   await setNewCommodityAndService({
  //     ...newCommodityAndService,
  //     changedValues,
  //   });
  // };
  const handleFormSubmit = async (changedValues) => {
    // await setNewCommodityAndService(changedValues);
    createCommodityAndServicesGroupHandler(changedValues);
  };

  // upload image

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState([]);
  const [imageOfFood, setImageOfFood] = useState([]);
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  // const ImageOfFoodChange = ({ fileList: newFileList }) => setImageOfFood(newFileList);
  const ImageOfFoodChange = ({ imageOfFood: newImageOfFood }) =>
    setImageOfFood(newImageOfFood);
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  // end of upload image

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session">تعریف کالا و خدمات</h5>

        <Form
          // layout="horizental"
          layout="vertical"
          // layout="inline"
          // {...formItemLayout}
          // layout={
          //     "span": 12,
          //     "offset": 12,
          //   },
          // initialValues={
          //   {
          //     items: [{ unitValue: "", eachPrimaryUnitEqualTo: "" }],
          //     features: [{ feature: "", feature_value: "0" }]
          //   }
          // }
          // onValuesChange={handleFormChangeValues}
          form={form}
          onFinish={handleFormSubmit}
          autoComplete="off"
          scrollToFirstError
          labelCol={{ xs: 24 }}
          // labelCol={{ xs: 12, sm: 9 }}
        >
          <Row gutter={8}>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="گروه کالا"
                name="goods_group_id"
                rules={[
                  {
                    required: true,
                    message: "گروه کالا اجباری است",
                  },
                ]}
              >
                <Select
                  // className={`${classNames.classes}`}
                  loading={!allCommodity?.[0]}
                  showSearch
                  // style={{
                  //   width: 200,
                  // }}
                  // onChange={test}
                  fieldNames="goods_group_id"
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  id="anbar_id"
                >
                  {allCommodityAndServicesGroup?.map((commodityAndService) => {
                    return (
                      <Option
                        key={commodityAndService.id}
                        value={commodityAndService.id}
                      >
                        {commodityAndService.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="شناسه"
                name="shenaseh"
                // rules={[
                //   {
                //     required: true,
                //     message: 'شناسه الزامی است',
                //   },
                // ]}
              >
                <Input placeholder="12345" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="نام"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "نام کالا اجباری است",
                  },
                ]}
              >
                <Input placeholder="نام کالا" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="واحد شمارش اصلی"
                name="unit_id"
                rules={[
                  {
                    required: true,
                    message: "نام کالا اجباری است",
                  },
                ]}
              >
                <Select
                  showSearch
                  loading={!allMeasurementUnits?.[0]}
                  // style={{
                  //   width: 200,
                  // }}
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  {allMeasurementUnits?.map((measurement) => {
                    return (
                      <Option key={measurement.id} value={measurement.id}>
                        {measurement.name}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="delivery"
                label="وضعیت رهگیری"
                rules={[
                  {
                    required: true,
                    message: "این فیلد اجباری است",
                  },
                ]}
              >
                <Select
                  // showSearch
                  // loading={!allMeasurementUnits?.[0]}
                  // style={{
                  //   width: 200,
                  // }}
                  placeholder="انتخاب فرمایید"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                >
                  <Option value="bedon_rahgiri">بدون رهگیری</Option>
                  <Option value="serial">سریال</Option>
                  {/* {allMeasurementUnits?.map((measurement) => {
                return (

                )
              })} */}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item name="has_feature" valuePropName="checked">
                <Checkbox
                  onChange={() => {
                    setHasFeature(!hasFeature);
                    form.setFieldsValue({
                      features: "",
                    });
                  }}
                >
                  دارای ویژگی می باشد
                </Checkbox>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item valuePropName="checked" name="returnable">
                <Checkbox>قابل مرجوع</Checkbox>
              </Form.Item>
            </Col>
          </Row>
          {/* start form list */}

          {/* {newCommodityAndService?.has_feature && ( */}
          {hasFeature && (
            <Row gutter={8}>
              <Col xs={24} md={12} lg={6}>
                <Form.List name="features">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: "flex", marginBottom: 8 }}
                          align="baseline"
                        >
                          <Form.Item
                            {...restField}
                            name={[name, "name"]}
                            label="نام ویژگی"
                            // disabled="true"
                            rules={[
                              {
                                required: true,
                                message: "نام ویژگی اجباری است",
                              },
                            ]}
                          >
                            <Input placeholder="وزن" />
                          </Form.Item>
                          <Form.Item
                            {...restField}
                            name={[name, "amounts"]}
                            label="مقدار"
                            rules={[
                              {
                                required: true,
                                message: "مقدار ویژگی اجباری است",
                              },
                            ]}
                          >
                            <Input placeholder="2 کیلوگرم" />
                            {/* <Select
                        showSearch
                        loading={!allMeasurementUnits?.[0]}
                        placeholder="انتخاب فرمایید"
                        optionFilterProp="children"
                        filterOption={(input, option) => option.children.includes(input)}
                        filterSort={(optionA, optionB) =>
                          optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                        }
                      >
                        {allMeasurementUnits?.map((measurement) => {
                          return (
                            <Option key={measurement.id} value={measurement.id}>
                              {measurement.name}
                            </Option>
                          )
                        })}

                      </Select> */}
                          </Form.Item>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="dashed"
                          onClick={() => add()}
                          block
                          icon={<PlusOutlined />}
                        >
                          ایجاد یک ویژگی جدید
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
                {/* end form list */}
              </Col>
            </Row>
          )}
          <Row gutter={8}>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item name="mohasebeh" valuePropName="checked">
                <Checkbox>محاسبه ارزش افزوده در داخل قیمت</Checkbox>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="ارزش افزوده"
                name="arzesh_afzoode"
                rules={[
                  {
                    required: true,
                    message: "این فیلد اجباری است",
                  },
                ]}
              >
                <Select
                  // showSearch
                  // loading={!allPeople?.[0]}
                  // style={{
                  //   width: 200,
                  // }}
                  placeholder="انتخاب فرمایید"
                  // optionFilterProp="children"
                  // filterOption={(input, option) => option.children.includes(input)}
                  // filterSort={(optionA, optionB) =>
                  //   optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  // }
                >
                  <Option value="darad">مالیات و عوارض</Option>
                  <Option value="nadarad">فاقد ارزش افزوده</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="نوع بارکد" name="barcode_type">
                <Select
                  // defaultValue="انتخاب فرمایید"
                  // initialvalues="انتخاب فرمایید"
                  placeholder="انتخاب فرمایید"
                  // style={{
                  //   width: 120,
                  // }}
                  // onChange={handleChange}
                >
                  <Option value="barcode_weight">بارکد وزنی</Option>
                  <Option value="barcode_number">بارکد تعدادی</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="بارکد" name="barcode">
                <Input placeholder="12345" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24} sm={12} md={6} xl={6}>
              <h6>واحد های فرعی شمارش</h6>
              {/* start form list */}
              <Form.List name="sub_unit">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, "each"]}
                          label="هر"
                          rules={[
                            { required: true, message: "مقدار اجباری است" },
                          ]}
                        >
                          <Input placeholder="واحد" />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, "unit"]}
                          rules={[
                            { required: true, message: "مقدار اجباری است" },
                          ]}
                          label="برابر است با یک"
                        >
                          <Select
                            showSearch
                            loading={!allMeasurementUnits?.[0]}
                            style={{
                              width: 120,
                            }}
                            placeholder="انتخاب فرمایید"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              option.children.includes(input)
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                          >
                            {allMeasurementUnits?.map((measurement) => {
                              return (
                                <Option
                                  key={measurement.id}
                                  value={measurement.name}
                                >
                                  {measurement.name}
                                </Option>
                              );
                            })}
                          </Select>
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        ایجاد یک واحد جدید
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Col>
          </Row>
          {/* end form list */}
          <Row gutter={8}>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="قیمت خرید" name="buy_price">
                <Input placeholder="قیمت خرید" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item
                label="قیمت فروش"
                name="sales_price"
                rules={[
                  {
                    required: true,
                    message: "این فیلد اجباری است",
                  },
                ]}
              >
                <Input placeholder="قیمت فروش" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="نقطه سفارش" name="order_point">
                <Input placeholder="نقطه سفاررش" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="میزان سفارش" name="order_amount">
                <Input placeholder="میزان سفاررش" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={8}>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="قفسه" name="shelf">
                <Input placeholder="قفسه" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="مدل" name="model">
                <Input placeholder="مدل" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="سازنده" name="manufacturer">
                <Input placeholder="سازنده" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6} xl={6}>
              <Form.Item label="شرح" name="description">
                <TextArea row={3} placeholder="توضیحات..." autoSize />
              </Form.Item>
            </Col>
          </Row>
          {/*<Col xs={24} sm={12} md={6} xl={6}> */}

          <Col xs={24} sm={12} md={8} xl={6}>
            <Form.Item name="" label="تصویر">
              <Upload
                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                maxCount={5}
              >
                {fileList.length >= 1 ? null : uploadButton}
              </Upload>
            </Form.Item>
            <Modal
              visible={previewOpen}
              title={previewTitle}
              footer={null}
              onCancel={handleCancel}
            >
              <img
                alt="example"
                style={{
                  width: "100%",
                }}
                src={previewImage}
              />
            </Modal>
          </Col>

          <Form.Item
          // {...buttonItemLayout}
          >
            {/* <Button
              htmlType="submit"
              type="primary"
              // onClick={createCommodityAndServicesGroupHandler}
            > */}
            <ButtonComponent value="ثبت" type="submit" />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default CreateCommodityAndServices;
